import React, { Component } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

class TouchGestureSeattle extends Component {
  constructor(props) {
    super(props);
    let radius = this.props.regionWidth
    let top = (this.props.regionHeight - radius) / 2;
    let right = - (this.props.regionWidth / 100 * 36.45);

    this._iconRef = null;

    this.state = {
      radius: radius,
      top: top,
      right: right,
      show: false
    }
  }

  componentDidMount() {
    if (this.props.show) {
      this.startInterval();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      if (this.props.show) {
        this.startInterval();
      } else {
        this.setState({
          show: false
        });
      }
    }
  }

  animateIcon = () => {
    let distance = .08733 * this.props.regionWidth;
    if (this._iconRef) {
      this._iconRef.animate([{
          transform: "scale(1.0)",
        },{
          transform: "scale(0.7)",
        }, {
          transform: `scale(0.7) translate(0px, -${distance}px)`,
        },
        {
          transform: `scale(1.0) translate(0px, -${distance}px)`,
        }
      ], {
          direction:"alternate",
          easing: "ease-in",
          fill: "both",
          duration: 1500,
          iterations: 2,
      });
    }
  }
  
  startInterval = () => {
    this.setState({
      show:true
    });
    setTimeout(() => {
      this.animateIcon();
    }, 1000);
  }

  render() {
    return(
      <div style={{ position:"absolute", top: this.props.contentY, left: this.props.contentX }}>
        <CSSTransitionGroup
          component='div'
          className="fastfadedelay"
          style={{ minHeight: '100%' }}
          transitionName='example'
          transitionEnterTimeout={0}
          transitionLeaveTimeout={0}>
          <div key={this.state.show}>
            {
              this.state.show ?
              <div>
                <div style={{ position:"absolute", left: this.props.regionWidth * .9475, top: .4366 * this.props.regionWidth }}>
                  <img ref={el => this._iconRef = el} src="/img/seattle/general/hand.png" alt="" style={{ width: .021 * this.props.regionWidth, zIndex: 9999 }}/>
                </div>
                <div style={{ color: "FFFFFF", position:"absolute", fontSize:.013 * this.props.regionWidth, width: .2751 * this.props.regionWidth, height: .0366 * this.props.regionWidth, top: .5065 * this.props.regionWidth, left: .7205 * this.props.regionWidth, fontWeight:"bold"  }}>SWIPE TO SEE MORE</div>
              </div>
              : null
            }
          </div>
        </CSSTransitionGroup>
      </div>
    );
  }
}

export default TouchGestureSeattle;


// WEBPACK FOOTER //
// ./src/Components/Theme/Seattle/TouchGestureSeattle.jsx